export const RightIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="17"
    viewBox="0 0 10 17"
    fill="none"
  >
    <path
      d="M9.70627 7.79374C10.0969 8.18437 10.0969 8.81874 9.70627 9.20937L3.70627 15.2094C3.31565 15.6 2.68127 15.6 2.29065 15.2094C1.90002 14.8187 1.90002 14.1844 2.29065 13.7937L7.5844 8.49999L2.29377 3.20624C1.90315 2.81562 1.90315 2.18124 2.29377 1.79062C2.6844 1.39999 3.31877 1.39999 3.7094 1.79062L9.7094 7.79062L9.70627 7.79374Z"
      fill="#94A3B8"
    />
  </svg>
);
